// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE (Supabase migration V2 - PREVIEW ONLY)
// version  : 3.0
// updated  : 2026-06-21
// protected: NO
// changelog: v3.0 (UAT-02 Fase 2) - Request->Dispatch. Kacab buat REQUEST (tanpa QR);
//            Admin Gudang asal scan QR (exact-match) -> dispatch; Admin Gudang tujuan terima.
// =============================================================================
import React from "react";
import { ArrowLeftRight } from "lucide-react";
import { useV2Auth } from "@/v2/V2AuthContext";
import { RequestDispatchFlow } from "@/v2/components/RequestDispatchFlow";
import { WAREHOUSES, defaultGudang, allowedWarehouses } from "@/v2/components/helpers";
import { GUDANG, KACAB } from "@/v2/menu";

export default function TransferPage() {
  const { me } = useV2Auth();
  const role = me?.role;
  const gudang = GUDANG.includes(role);
  const kacab = KACAB.includes(role);
  const src = defaultGudang(me?.region);
  const tgt = WAREHOUSES.filter((w) => w !== src)[0];
  const srcOpts = allowedWarehouses(me);   // asal transfer terbatas scope; tujuan tetap boleh lintas-region

  return (
    <RequestDispatchFlow
      testid="v2-transfer-page"
      title="Transfer Gudang"
      icon={ArrowLeftRight}
      docType="transfer"
      listPath="/api/v2/transfers"
      createPath="/api/v2/transfers"
      dispatchPath={(id) => `/api/v2/transfers/${id}/dispatch`}
      receivePath={(id) => `/api/v2/transfers/${id}/receive`}
      cancelPath={(id) => `/api/v2/transfers/${id}/cancel`}
      sourceLabel="Gudang Asal"
      targetLabel="Gudang Tujuan"
      sourceOptions={srcOpts}
      targetOptions={(s) => WAREHOUSES.filter((w) => w !== s)}
      defaultSource={src}
      defaultTarget={tgt}
      buildRequestBody={({ source, target, lines }) => ({ from_location: source, to_location: target, request_lines: lines })}
      canCreate={kacab}
      canDispatch={gudang}
      canReceive={gudang}
      canCancel={kacab || gudang}
      receiverLocation={src}
      allowMou
      createLabel="Ajukan Transfer"
      emptyTitle="Belum ada transfer gudang"
      emptyDescription="Transfer antar-gudang muncul di sini setelah diajukan Kepala Cabang, lalu Admin Gudang asal scan QR untuk mengirim."
    />
  );
}
